var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popupVisible),
      expression: "popupVisible"
    }],
    staticClass: "wx-guide-popup",
    on: {
      "click": _vm.close
    }
  }, [_c('mt-popup', {
    attrs: {
      "pop-transition": "popup-fade",
      "closeOnClickModal": "false"
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('div', [_c('h2', [_vm._v("如何查看微信号?")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("进入微信APP, 找到“个人信息”页，就可以看到微信号")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如微信号是空的，请您马上进行设置，以享受更便利的服务")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/wx-guide01.png"
    }
  })])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-1544656e","hasScoped":false}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/WxIdGuide.vue
// module id = 231
// module chunks = 0